export { default } from '@ember-data/adapter/json-api';
